import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import { Container, Modal, Button } from 'semantic-ui-react';
import { flattenToAppURL } from '@plone/volto/helpers';
import { Icon } from 'iovisit-theme/components';
import DefaultImageSVG from '@plone/volto/components/manage/Blocks/Listing/default-image.svg';
import { ArtworkDetailsModal } from 'iovisit-museum-theme/components/Views';

const messages = defineMessages({
  preview_image_title: {
    id: 'preview_image_title',
    defaultMessage: "Immagine di anteprima dell'opera",
  },
  close_modal: {
    id: 'close_modal',
    defaultMessage: 'Chiudi la modale',
  },
});

const ArtworkDetailsCard = ({ content }) => {
  const intl = useIntl();
  const [previewImage, setPreviewImage] = useState(null);

  const modalCloseRef = React.useRef();

  const objectArtwork = [
    {
      icon_prefix: 'fas',
      icon: 'landmark',
      title: content.museum?.title,
      subtitle: content.room?.title,
    },
    {
      icon_prefix: 'fas',
      icon: 'user',
      title: content.author_name,
      subtitle: content.author_nickname,
    },
    {
      icon_prefix: 'fas',
      icon: 'book',
      title: content.period,
      subtitle: null,
    },
    {
      icon_prefix: 'fas',
      icon: content.typology ? content.typology?.token : null,
      title: content.typology ? content.typology?.title : null,
      subtitle: null,
    },
  ];

  useEffect(() => {
    if (document.querySelector('#modalGallery .close')) {
      document.querySelector('#modalGallery .close').focus();
    }
  });

  const handleFocusOut = (e) => {
    e.preventDefault();
    document.querySelector('#modalGallery .close').click();
    document.querySelector('.card-image-zoom-button .button').focus();
  };

  /* TO DO: sostituire i dati statici con quelli dinamici */

  return (
    <section id="artwork-details-card" className="full-width">
      <Container>
        <div className="card">
          <div className="card-image">
            {content.main_image ? (
              <>
                <img
                  alt={intl.formatMessage(messages.preview_image_title)}
                  role="presentation"
                  src={flattenToAppURL(
                    content.main_image.scales?.large?.download,
                  )}
                  loading="lazy"
                />
                <div className="card-image-zoom-button">
                  <Button
                    icon
                    basic
                    onClick={() => {
                      setPreviewImage(
                        flattenToAppURL(
                          content.main_image.scales?.large?.download,
                        ),
                      );
                    }}
                  >
                    <Icon prefix="fas" icon="search-plus" className="icon" />
                  </Button>
                </div>
              </>
            ) : (
              <img src={DefaultImageSVG} alt="" loading="lazy" />
            )}

            <div className="card-image-description">
              {content.main_image_caption ?? content.title}
            </div>
          </div>
          <div className="card-content">
            {objectArtwork.map((item) => {
              return item.title || item.subtitle ? (
                <div className="row">
                  {item.icon && (
                    <div className="symbol">
                      <Icon
                        prefix={item.icon_prefix}
                        icon={item.icon}
                        className="icon"
                      />
                    </div>
                  )}
                  <div className="text">
                    {item.title && <h4>{item.title}</h4>}
                    {item.subtitle && <p>{item.subtitle}</p>}
                  </div>
                </div>
              ) : (
                <></>
              );
            })}
          </div>
        </div>
      </Container>
      <Modal
        id="modalGallery"
        closeIcon={
          <button
            onKeyDown={(e) => handleFocusOut(e)}
            ref={modalCloseRef}
            className="close"
            title={intl.formatMessage(messages.close_modal)}
          >
            <Icon prefix="fa" icon="times" className="close icon" />
          </button>
        }
        closeOnEscape={true}
        onClose={() => {
          setPreviewImage(null);
        }}
        open={previewImage != null}
        size="large"
        className="modal-artwork-details"
      >
        <Modal.Content>
          <div className="preview-image-modal">
            <div className="single-image">
              <img
                alt=""
                role="presentation"
                src={previewImage}
                loading="lazy"
              />
            </div>
            <ArtworkDetailsModal artwork={content} />
          </div>
        </Modal.Content>
      </Modal>
    </section>
  );
};

ArtworkDetailsCard.propTypes = {
  content: PropTypes.object.isRequired,
};

export default ArtworkDetailsCard;
